import { plainToClass } from 'class-transformer';
import {
  API_LANGUAGE_FIND_ALL,
  API_LANGUAGE_FIND_ONE,
  API_LANGUAGE_CREATE,
  API_LANGUAGE_DELETE,
  API_LANGUAGE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { FindAllResponse } from '../types';
import { LanguageDto } from '../dto';

export class LanguageApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<LanguageDto>> {
    return this.httpClient
      .get(API_LANGUAGE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(LanguageDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<LanguageDto> {
    return this.httpClient
      .get(API_LANGUAGE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(LanguageDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<LanguageDto> {
    return this.httpClient.post(API_LANGUAGE_CREATE, data).then(({ data }) => {
      return plainToClass(LanguageDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<LanguageDto> {
    return this.httpClient.put(API_LANGUAGE_UPDATE, data).then(({ data }) => {
      return plainToClass(LanguageDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_LANGUAGE_DELETE, {
      pathParams: { uuid }
    });
  }
}
